import { getPlans, getUserPlan, setUserPlan } from '../api/plan.api';
import { useMutation, useQuery, useQueryClient } from 'react-query';

const queryKey = 'user-plan';
const querySettings = { cacheTime: Infinity, staleTime: 300000 };

export const usePlan = () => {
    const qc = useQueryClient();
    const { mutate: setPlan } = useMutation(setUserPlan, {
        onMutate: async (plan) => {
            await qc.cancelQueries(queryKey);
            const prev = qc.getQueryData(queryKey);
            qc.setQueryData(queryKey, plan);
            return { prev, next: plan };
        },
        onError: (err, newTodo, { prev }) => qc.setQueryData(queryKey, prev),
    });
    const { data: plan, ...restQuery } = useQuery(
        queryKey,
        getUserPlan,
        querySettings,
    );
    return {
        ...restQuery,
        plan,
        industry: plan ? plan.industry : undefined,
        setPlan,
    };
};

export const usePlans = () =>
    useQuery('plans', getPlans, { cacheTime: Infinity, staleTime: Infinity });
